// PLAT-TOS-LAYERED-1 — accept one product's terms addendum.
// The state itself is read from /v1/me (user.product_terms); this is the only write.
import { apiClient } from '@/api/client'

/** Records acceptance of `version` of `product`'s addendum. The server refuses
 *  (409) a version that is no longer current, so the person must re-read. */
export async function acceptProductTerms(product: string, version: string): Promise<void> {
  await apiClient.post(`/v1/product-terms/${encodeURIComponent(product)}/accept`, { version })
}
